import React, { useContext } from 'react';
import { useLocation } from 'react-router-dom';
import { topNavLinks } from '../../data/content';
import NavigationItem from '../NavItem';
import CartContext from '../../context/CartContext';

const TopNav = () => {
  let { event } = useContext(CartContext);
  const loc = useLocation()
  const links = [...topNavLinks];

  if (event.name) {
    links.splice(3, 0, {
      id: 'ee46s',
      name: event.name,
      href: event.href,
    });
  }

  const applyEventColor =
    event?.name && loc.pathname.includes('event');

  return (
    <div className="hidden bg-primary py-3 lg:block" style={{ background: applyEventColor ? event.color : undefined }}>
      <div className="container flex items-center justify-between text-sm text-white">
        <div className="flex items-center divide-x divide-neutral-100">
          {links.map((item) => (
            <NavigationItem menuItem={item} key={item.id} />
          ))}
        </div>
        <div className="bg-white p-2 font-bold border rounded-lg" style={{ color: "rgb(0 110 186)" }}>
          <p>📦 Envío gratis a partir de los $160000!</p>
        </div>
      </div>
    </div>
  );
};

export default TopNav;
